export const texts = [
    [
        {
          text: 'It emerged encrypted',
          count: 200,
          fontSize: 30,
        },
        {
          text: 'I guessed the process',
          count: 400,
          fontSize: 50,
        },
        {
          text: 'What did it say?',
          count: 600,
          fontSize: 100,
        },
        {
          text: '#&%(@_@#_%#%!',
          count: 800,
          fontSize: 100,
        },
        {
          text: '#%(@_@#_%#%!4',
          count: 825,
          fontSize: 100,
        },
        {
          text: '#&%(@_@#_%#41',
          count: 850,
          fontSize: 100,
        },
        {
          text: '#&%(@_@#_%417',
          count: 875,
          fontSize: 100,
        },
        {
          text: '#&%(@_@#_4175',
          count: 900,
          fontSize: 100,
        },
        {
          text: '#&%(@_@#41756',
          count: 925,
          fontSize: 100,
        },
        {
          text: '#&%(@_@4175671',
          count: 950,
          fontSize: 100,
        },
        {
          text: '#&%(@_41756713',
          count: 975,
          fontSize: 100,
        },
        {
          text: '',
          count: 1000,
        }
      ],
      [
        {
          text: 'RRRRRR',
          count: 200,
          fontSize: 500,
        },
        {
          text: 'UUUUU',
          count: 400,
          fontSize: 500,
        },
        {
          text: 'THERE',
          count: 600,
          fontSize: 500,
        },
        {
          text: '?????',
          count: 800,
          fontSize: 500,
        },
        {
          text: '',
          count: 1000,
          fontSize: 500,
        },
      ],
      [
        {
          text: 'What would you reply?',
          count: 200,
          fontSize: 100,
        },
        {
          text: 'Would you reply?',
          count: 400,
          fontSize: 50,
        },
        {
          text: 'I would say,',
          count: 600,
          fontSize: 100,
        },
        {
          text: 'nothing',
          count: 800,
          fontSize: 10,
        },
        {
          text: 'and let it wash away',
          count: 1000,
          fontSize: 50,
        },
        {
          text: '',
          count: 1200,
        },
      ],
];

export default texts;